import type { OptimizationIDModel, OptimizationModel } from '@/shared/generated'

import { OptimizationStatus } from '@/shared/generated'

/**
 * Returns only the finished and locked optimizations
 * @param optimizations - The optimizations to filter
 * @returns The filtered optimizations
 */
export const getFinishedAndLockedOptimizations = (
	optimizations: OptimizationModel[]
): OptimizationIDModel[] =>
	optimizations
		.filter(({ status }) =>
			[OptimizationStatus.Finished, OptimizationStatus.Locked].includes(status)
		)
		.map(({ optimization_group_id, id }) => ({
			optimization_group_id,
			optimization_id: id!,
		}))

/**
 * Returns a map of optimizations by optimization group id
 * @param optimizations - The optimizations to map
 * @returns The map of optimizations
 */
export const getOptimizationsMap = (optimizations?: OptimizationModel[]) =>
	optimizations?.reduce(
		(acc, optimization) => ({
			...acc,
			[optimization.optimization_group_id]: optimization,
		}),
		{}
	) as Record<string, OptimizationModel>
